export const CLOSE_NEW_LINE = 'CLOSE_NEW_LINE'
export const CHANGE_WINDOW_WIDTH = 'CHANGE_WINDOW_WIDTH'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js